<template>
  <v-layout>
    <v-main :class="containerState">
      <v-container fluid v-if="!loadingRoles">
        <AppBar :kpi="kpi" :realm="realm" :apiUrl="mfConfig.api" @snackbarEvent="snackbarEvent"
          :disabled="isReadOnly" />
        <WizardStepper :step="step" :is-admin="isAdmin" :is-common="isCommonKPI"
          @update:step="(newValue) => (step = newValue)" :disabled="isReadOnly" />

        <!--Snackbar-->
        <v-snackbar v-model="snackbar" top color="green" timeout="5000">
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">OK</v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import axios from "axios";
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import AppBar from "./components/AppBar.vue";
import WizardStepper from "./components/WizardStepper.vue";

export default {
  name: "KpiEditorControlPanel",
  components: { AppBar, WizardStepper },
  mixins: [events, utils],
  props: ["mfConfig", "realm"],
  data: function () {
    return {
      containerState: "expanded",
      loggedUserId: "",
      snackbar: false,
      snackbarText: "",
      overlay: false,
      search: "",
      kpi: JSON.parse(sessionStorage.getItem("kpi")),
      page: location.pathname.split("/").pop(),
      roles: [],
      loadingRoles: true,
      unregisterRouterGuard: null,
    };
  },
  async beforeMount() {
    this.loadingRoles = true;
    await this.getRoles();
    this.loadingRoles = false;

    if (this.isAdmin && this.isCommonKPI && !this.isManualKpi() && location.pathname.includes("definition")) {
      this.$router.replace("/editor/formula");
    }
  },
  beforeUnmount() {
    if (this.unregisterRouterGuard) {
      this.unregisterRouterGuard();
      this.unregisterRouterGuard = null;
    }
  },
  created() {
    if (!this.kpi) {
      this.$router.push("/");
    }
  },
  mounted() {
    this.loggedUserId = localStorage.getItem("loggedUserId");

    document.addEventListener("language-localstorage-changed", (event) => {
      this.setLocale(event.detail.storage);
    });

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });

    this.unregisterRouterGuard = this.$router.beforeEach((to, _from, next) => {
      if (this.isAdmin && this.isCommonKPI && !this.isManualKpi() && to.path.includes("definition")) {
        next({ path: "/editor/formula", replace: true });
        return;
      }
      if (to.path.includes("definition")) {
        this.page = "definition";
      } else if (to.path.includes("formula")) {
        this.page = "formula";
      } else if (to.path.includes("dashboard")) {
        this.page = "dashboard";
      } else if (to.path.includes("summary")) {
        this.page = "summary";
      } else {
        this.page = to.path.split("/").pop();
      }
      next();
    });
  },
  computed: {
    isAdmin() {
      return this.roles && this.roles.includes("admin");
    },
    isViewer() {
      return this.roles && this.roles.includes("viewer");
    },
    isCommonKPI() {
      if (!this.kpi) return false;
      return this.kpi.commonKpi === true;
    },
    // Disabilita le modifiche per l'Admin sui KPI non Common (comportamento identico al viewer)
    isReadOnly() {
      if (this.isViewer) return true;
      if (this.isAdmin) {
        return !this.isCommonKPI;
      }
      return false;
    },
    step() {
      const isManual = this.isManualKpi();
      const hideDef = this.isAdmin && this.isCommonKPI && !isManual;
      if (hideDef) {
        const stepMap = { formula: "1", dashboard: "2", summary: "3" };
        return this.page ? (stepMap[this.page] || "1") : "1";
      }
      const stepMap = {
        definition: "1", formula: "2",
        dashboard: isManual ? "2" : "3",
        summary: isManual ? "3" : "4",
      };
      return this.page ? (stepMap[this.page] || "1") : "1";
    },
  },
  methods: {
    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
    isManualKpi() {
      try {
        if (!this.kpi) return false;
        const type = ((this.kpi.kpiType || this.kpi.type) || "").toString();
        return /manu/i.test(type);
      } catch (_e) {
        return false;
      }
    },
    async getRoles() {
      try {
        const response = await axios.get(
          `${this.mfConfig.api}/${this.realm}/me`,
          { withCredentials: true }
        );
        const rawRoles = response.data.roles || [];
        this.roles = rawRoles.map(role => role.replace(/^kpim-/, ''));
      } catch (error) {
        console.error("Error fetch roles :", error);
      }
    },
  },
};
</script>
<style scoped>
main.expanded {
  margin-left: 56px;
}

main.expanded header#upp-bar {
  margin-left: 56px;
  width: calc(100% - 56px) !important;
}

main.reduced {
  margin-left: 256px;
}

main.reduced header#upp-bar {
  margin-left: 256px;
  width: calc(100% - 256px) !important;
}
</style>
